import { z } from "zod";

export const UserLayoutSchema = z.object({
  ID: z.number(),
  FirstName: z.string(),
  LastName: z.string(),
  Email: z.string().nullable(),
  Phone: z.string().nullable(),
  LanguageID: z.number(),
  GUID: z.string().optional(),
});

export type IUserLayout = z.infer<typeof UserLayoutSchema>;

export type IUserCredentials = {
  UserID: string;
  UserSecret?: string;
};
